import PortalVue from 'portal-vue';
/**
 * Se agregan las librerias de terceros estandar
 */
export function addLibs(Vue) {
    Vue.use(PortalVue);
}
//# sourceMappingURL=index.js.map